'use client'

import dynamic from 'next/dynamic'

// Lazy-load heavy below-fold components - excluded from initial JS bundle

export const LazyTrustedBySection = dynamic(
  () =>
    import('@domain/landing/TrustedBySection').then((m) => ({
      default: m.TrustedBySection,
    })),
  { ssr: false },
)

export const LazyHeroCTACarousel = dynamic(
  () =>
    import('@components/ui/custom-carousel/HeroCTACarousel').then((m) => ({
      default: m.HeroCTACarousel,
    })),
  { ssr: false },
)
